import React, { useState, useEffect } from "react";
import ISODateStringDate from "../../functions/ISODateStringDate";
import ISODateStringTime from "../../functions/ISODateStringTime";
import LanguageContext from "../../context/languagecontext";
import Styles from "./Instrument.module.scss";

const InstrumentBooleanText = props => {
  const booleanValue = Number(props.data.StringValue);
  const [status, setStatus] = useState(booleanValue);
  const { language } = React.useContext(LanguageContext);

  useEffect(() => {
    let isCanceled = false;

    if (isCanceled) {
      return;
    }
    if (!isCanceled) {
      booleanValue === 1 ? setStatus(1) : setStatus(0);
    }

    return () => {
      isCanceled = true;
    };
  }, [booleanValue, setStatus]);

  return (
    <div className={Styles.instrument}>
      <svg viewBox="0 0 300 300">
        <circle fill="#263d42" cx="150" cy="150" r="150" />

        <circle
          fill="transparent"
          cx="150"
          cy="150"
          r="130"
          strokeWidth="5"
          stroke={status === 1 ? "#72f887" : "#516468"}
        />
        <line
          x1="150"
          y1="10"
          x2="150"
          y2="120"
          strokeWidth="30"
          stroke="#263d42"
        />
        <line
          x1="150"
          y1="10"
          x2="150"
          y2="120"
          strokeWidth="5"
          stroke={status === 1 ? "#72f887" : "#516468"}
        />

        <text
          className={Styles.value}
          fill="#ffffff"
          transform="translate(150 163)"
          textAnchor="middle"
        >
          {status === 0
            ? language === "fr"
              ? props.data.BoolFrench0
              : language === "it"
              ? props.data.BoolItalian0
              : props.data.BoolGerman0
            : status === 1
            ? language === "fr"
              ? props.data.BoolFrench1
              : language === "it"
              ? props.data.BoolItalian1
              : props.data.BoolGerman1
            : null}
        </text>

        <text
          className={Styles.timestamp}
          fill="#ffffff"
          transform="translate(150 190)"
          textAnchor="middle"
        >
          <tspan x="0" dy="1.2em">
            {ISODateStringDate(new Date(props.data.SourceTimestamp))}
          </tspan>
          <tspan x="0" dy="1.2em">
            {ISODateStringTime(new Date(props.data.SourceTimestamp))}
          </tspan>
        </text>
      </svg>
      <div className={Styles.instrumentLabel}>
        <h3>
          {language === "fr"
            ? props.data.LabelFrench
            : language === "it"
            ? props.data.LabelItalian
            : props.data.LabelGerman}
        </h3>
      </div>
    </div>
  );
};

export default InstrumentBooleanText;
